<template>
	<app tabbar>
		<!-- <div class="elder" @click="elderMode">{{elder ? '常规版' : '长辈版'}}</div> -->
		<div class="banner"></div>
		
		<div v-if="power('0')" class="module register flex-column flex-center">
			<p>首次进入系统请完善资料<br>才能办理相关业务哦！</p>
			<c-button @click="navigateTo('/register')">完善资料</c-button>
		</div>
		
		<div v-if="(!userInfo.id || power('7')) && insuranceList[0] && insuranceList[0].length > 0" class="module">
			<div class="title">保函申请</div>
			<ul class="company-list flex-between flex-wrap">
				<li v-for="(item, i) in insuranceList[0]" :key="i" class="flex-center-cross" @click="navigateTo('/insurance_apply', {companyId: item.id})">
					<img class="logo" :src="item.image">
				</li>
			</ul>
		</div>
		
		<div v-if="(!userInfo.id || power('7')) && insuranceList[2] && insuranceList[2].length > 0" class="module">
			<div class="title flex-baseline">
				<p>银行金融机构</p>
			</div>
			<ul class="company-list flex-between flex-wrap">
				<li v-for="(item, i) in insuranceList[2]" :key="i" class="flex-center-cross" @click="navigateTo('/insurance_apply', {companyId: item.id})">
					<img class="logo" :src="item.image">
				</li>
			</ul>
		</div>
		
		<div v-if="(!userInfo.id || power('7')) && insuranceList[1] && insuranceList[1].length > 0" class="module">
			<div class="title flex-baseline">
				<p>小额保函</p>
				<span>项目合同金额小于80万</span>
			</div>
			<ul class="company-list flex-between flex-wrap">
				<li v-for="(item, i) in insuranceList[1]" :key="i" class="flex-center-cross" @click="navigateTo('/insurance_apply', {companyId: item.id})">
					<img class="logo" :src="item.image">
				</li>
			</ul>
		</div>
		
		<div class="module">
			<div class="title">业务办理</div>
			<ul class="menu-list flex-wrap">
				<li v-for="(item, i) in menuList" :key="i" class="flex-column flex-center" @click="navigateTo(item.path)">
					<i class="tf" :class="item.meta.icon"></i>
					<p>{{item.meta.name}}</p>
					<ins v-if="item.meta.icon.includes('message') && messageTotal > 0" class="dot">{{messageTotal}}</ins>
				</li>
			</ul>
		</div>
		
		<div class="module">
			<div class="title flex-between-center">
				<p>政策与通知</p>
				<a @click="navigateTo('/notice')">查看更多<i class="tf tf-angle-right"></i></a>
			</div>
			<ul class="notice-list">
				<li v-for="(item, i) in noticeList" :key="i" @click="navigateTo('/notice_detail', {id: item.id})">
					<p class="ellipsis-2">{{item.title}}</p>
					<span>{{item.create_date}}</span>
				</li>
			</ul>
		</div>
		
		<div class="explain">
			<p>浙江银江智能信息技术有限公司 提供技术支持</p>
			<p>平台客服邮箱：yjszbh@163.com</p>
			<!-- <p>咨询服务热线：<a class="s-link" @click="callHandle">{{tel}}</a></p> -->
		</div>
	</app>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				insuranceList: [],
				noticeList: [],
				tel: '0577-63110290'
			}
		},
		
		computed: {
			...mapState(['elder', 'userInfo', 'messageTotal']),
			...mapGetters(['power', 'menuList'])
		},
		
		mounted() {
			this.$store.dispatch('updateMessageTotal');
			
			this.request({
				url: '/bxgs/list',
				success: data => {
					this.insuranceList = [
						data.filter(item => item.type == 1),
						data.filter(item => item.type == 2),
						data.filter(item => item.type == 3)
					];
				}
			});
			
			this.request({
				url: '/announcement/home_list',
				success: data => {
					this.noticeList = data;
				}
			});
		},
		
		methods: {
			elderMode() {
				this.$store.commit('setElder', !this.elder);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.elder {
		position: absolute;
		right: 0;
		top: .15rem;
		border-radius: .32rem 0 0 .32rem;
		padding: 0 .12rem 0 .2rem;
		line-height: .64rem;
		font-size: .3rem;
		color: #fff;
		background: #FA7312;
	}
	
	.banner {
		height: 2.72rem;
		background-image: url('~@/assets/image/banner_home.jpg');
		background-position: center;
		background-size: cover;
	}
	
	.module {
		border-radius: .2rem;
		padding: .24rem 0;
		margin: .24rem;
		background: #fff;
		
		.title {
			position: relative;
			padding-left: .2rem;
			margin: 0 .24rem;
			line-height: .52rem;
			font-size: .36rem;
			font-weight: bold;
			color: #1F1F1F;
			
			elder({
				line-height: .7rem,
				font-size: .5rem
			})
			
			&:before {
				content: '';
				position: absolute;
				left: 0;
				top: .1rem;
				width: .06rem;
				height: .32rem;
				background: #0366F1;
				
				elder({
					top: .12rem,
					height: .44rem
				})
			}
			
			span {
				margin-left: .16rem;
			}
			
			span, a {
				font-size: .24rem;
				font-weight: normal;
				color: #999;
				
				elder({
					font-size: .36rem
				})
				
				.tf {
					margin-left: .5em;
				}
			}
		}
	}
	
	.register {
		height: 2.88rem;
		
		p {
			margin-bottom: .26rem;
			line-height: .46rem;
			font-size: .32rem;
			text-align: center;
			color: #E15B5E;
			
			elder({
				line-height: .6rem,
				font-size: .44rem
			})
		}
	}
	
	.company-list {
		padding: 0 .24rem;
		
		li {
			box-sizing: border-box;
			width: 3.16rem;
			height: 1.2rem;
			padding: 0 .1rem;
			margin-top: .2rem;
			background: linear-gradient(90deg, rgba(243,251,254,0), #F3FBFE);
		}
	}
	
	.menu-list {
		margin-top: .2rem;
		
		li {
			position: relative;
			width: 33.3333%;
			padding: .22rem 0;
			color: #363A44;
			
			.tf {
				font-size: .48rem;
				color: #0366F1;
				
				elder({
					font-size: .68rem
				})
			}
			
			p {
				margin-top: .22rem;
				font-size: .28rem;
				text-align: center;
				white-space: nowrap;
				
				elder({
					font-size: .4rem
				})
			}
			
			ins {
				position: absolute;
				left: 50%;
				top: .1rem;
				box-sizing: border-box;
				min-width: .32rem;
				height: .32rem;
				border-radius: .16rem;
				padding: 0 .08rem;
				margin-left: .1rem;
				line-height: .34rem;
				font-size: .24rem;
				text-align: center;
				color: #fff;
				background: #E63633;
			}
		}
	}
	
	.notice-list {
		li {
			padding: 0 .24rem .1rem;
			margin-top: .24rem;
			
			p {
				margin-bottom: .16rem;
				line-height: .48rem;
				font-size: .32rem;
				color: #1F1F1F;
				
				elder({
					line-height: .66rem,
					font-size: .46rem
				})
			}
			
			span {
				font-size: .26rem;
				color: #999;
				
				elder({
					font-size: .38rem
				})
			}
		}
	}
	
	.explain {
		margin-bottom: .24rem;
		line-height: .4rem;
		font-size: .24rem;
		text-align: center;
		color: #B3B5B9;
		
		elder({
			line-height: .6rem,
			font-size: .34rem
		})
	}
</style>